export const STEP = {
  RV: 1,
  PERIOD: 2,
  LOCATION: 3,
  ADDONS: 4,
  SUMMARY: 5
};

export const STEPS_COUNT = Object.keys(STEP).length;
